export interface PersonalHistory {
  names: string[];
  birthDates: string[];
  channeledNames: string[];
}

const STORAGE_KEY = "tarot_recent_personal_details_v1";
const MAX_RECENT = 5;

export const emptyPersonalHistory: PersonalHistory = { names: [], birthDates: [], channeledNames: [] };

export function readPersonalHistory(): PersonalHistory {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    if (!value) return emptyPersonalHistory;
    const readList = (items: unknown): string[] =>
      Array.isArray(items) ? items.filter((item): item is string => typeof item === "string").slice(0, MAX_RECENT) : [];
    return { names: readList(value.names), birthDates: readList(value.birthDates), channeledNames: readList(value.channeledNames) };
  } catch {
    return emptyPersonalHistory;
  }
}

export function rememberPersonalDetails(history: PersonalHistory, details: Partial<{ name: string; birthDate: string; channeledName: string }>): PersonalHistory {
  const add = (items: string[], value?: string): string[] => {
    const trimmed = value?.trim();
    return trimmed ? [trimmed, ...items.filter((item) => item.toLocaleLowerCase() !== trimmed.toLocaleLowerCase())].slice(0, MAX_RECENT) : items;
  };
  const next = {
    names: add(history.names, details.name),
    birthDates: add(history.birthDates, details.birthDate),
    channeledNames: add(history.channeledNames, details.channeledName),
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Browser storage may be unavailable; the form can still proceed.
  }
  return next;
}
